import React from "react";
import type { GroupProps } from "./types";

const Group = ({ children }: GroupProps) =>
  React.Children.toArray(children)
    .filter(React.isValidElement<{ divider?: boolean }>)
    .map((child, index, array) =>
      React.cloneElement(child, {
        divider: index < array.length - 1,
      })
    );

export default Group;
